// extracted by mini-css-extract-plugin
export default {"inviteEntireTeamTooltip":"InviteEntireTeam_inviteEntireTeamTooltip__in8cc"};